export const formatDate = (item) => {
  if (item != null && item !== "0001-01-01T00:00:00") {
    item = item.split("T")[0];
    const day = item.substring(8, 10);
    const month = item.substring(5, 7);
    const year = item.substring(0, 4);
    return `${day}-${month}-${year}`;
  }
};

export const formatDateTime = (item) => {
  if (item != null && item !== "0001-01-01T00:00:00") {
    const itemTime = item.split("T")[1];
    item = item.split("T")[0];
    const day = item.substring(8, 10);
    const month = item.substring(5, 7);
    const year = item.substring(0, 4);

    let [hours, minutes] = itemTime.split(":");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minutesFormatted = minutes.padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutesFormatted} ${ampm} `;
  }
};
